import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import LookOutRegistered from './LookOutRegistered'
import LookOutEmergency from './LookOutEmergency'
import LookOutConfirmed from './LookOutConfirmed'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { MdErrorOutline } from 'react-icons/md'
import { GetAllByUser } from "../../../configurations/crud/opdCentersCrud"
import Datepicker from 'react-tailwindcss-datepicker'
import { FaClinicMedical } from 'react-icons/fa'
import Select from '../../controls/Select'
import moment from 'moment'
import ForDateShortReport from '../report/ForDateShortReport'

export default function LookOut({ }) {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [serachPatient, setSerachPatient] = useState("")
    const [isSerachPatient, setIsSerachPatient] = useState(0)
    const [opdCenters, setOpdCenter] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState("");
    const [viewUsers, setViewUsers] = useState(1);
    const [value, setValue] = useState({
        startDate: new Date(),
        endDate: new Date()
    });

    useEffect(() => {
        getAllOpdCenters()
    }, [])
    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUser()
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    setOpdCenter(mdata.data);
                } else {
                    setOpdCenter([]);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setOpdCenter([]);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }
    return (

        <Container>

            <div class="flex flex-col w-full ">
                <div class="w-full">
                    <Card isBorder={true} borderColor='border-brand-400' title={"Look Out OPD"} >
                        <div className='flex flex-col sm:flex-row gap-2'>
                            <div className='w-full'>
                                <label className="block mb-1 text-sm font-medium text-gray-700">Select Center</label>
                                <Select
                                    Icon={<FaClinicMedical className='text-red-600 text-lg' />}
                                    value={selectedCenter}
                                    onChange={(e) => setSelectedCenter(e.target.value)}
                                >
                                    <option value="">Select Center...</option>
                                    {opdCenters.map(item => (
                                        <option key={item.id} value={item.id}>{item.centerName}</option>
                                    ))}
                                </Select>
                            </div>
                            <div className='w-full'>
                                <label className="block mb-1 text-sm font-medium text-gray-700">Select Date</label>
                                <Datepicker
                                    popoverDirection='down'
                                    useRange={false}
                                    asSingle={true}
                                    displayFormat="DD/MM/YYYY"
                                    readOnly={true}
                                    primaryColor={"sky"}
                                    value={value}
                                    onChange={newValue => setValue(newValue)}
                                    inputClassName="outline-blue-400 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                                />
                            </div>
                        </div>
                    </Card>
                </div>
                {selectedCenter && value.startDate &&
                    <>
                        <div class="my-2"></div>
                        <ForDateShortReport centerId={selectedCenter} forDate={moment(new Date(value.startDate)).format("MM/DD/YYYY")} />
                        <div class="w-full" >
                            <Card isBorder={true} >
                                <div class="px-2 py-2"></div>
                                <div class=" flex w-full" role="group">
                                    <button type="button" onClick={(e) => setViewUsers(1)} class={(viewUsers == 1 ? "bg-blue-500" : "bg-gray-400") + " rounded-l-lg px-2 sm:px-4 py-2 sm:text-sm font-semibold text-xs text-white  border-gray-200 hover:bg-blue-400 focus:z-10 focus:ring-2 focus:ring-blue-500 active:bg-blue-600"}>
                                        Registered
                                    </button>
                                    <button type="button" onClick={(e) => setViewUsers(2)} class={(viewUsers == 2 ? "bg-green-500" : "bg-gray-400") + " px-2 sm:px-4 py-2 sm:text-sm font-semibold text-xs text-white  border-gray-200 hover:bg-green-400 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600"}>
                                        Confirmed
                                    </button>
                                    <button type="button" onClick={(e) => setViewUsers(3)} class={(viewUsers == 3 ? "bg-red-500" : "bg-gray-400") + " rounded-r-lg sm:rounded-none px-2 sm:px-4 py-2 sm:text-sm font-semibold text-xs text-white  border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-2 focus:ring-red-500 active:bg-red-600"}>
                                        Emergency
                                    </button>
                                    <div className='hidden sm:block w-full'>
                                        <div class="flex items-center w-full">
                                            <div class="w-full">
                                                <input type="text" value={serachPatient} onChange={(e) => setSerachPatient(e.target.value)} class="outline-none bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-r-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2.5" placeholder={`Search ${viewUsers == 1 ? "registered" : viewUsers == 2 ? "confirmed" : "emergency"} patient...`} required />
                                            </div>
                                            <button onClick={() => setIsSerachPatient(pre => pre + 1)} class="p-2.5 ms-2 text-sm font-medium text-white bg-brand-500 rounded-lg border border-brand-600 hover:bg-brand-600 focus:ring-4 focus:outline-none focus:ring-brand-600">
                                                <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                                </svg>
                                                <span class="sr-only">Search</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {viewUsers == 1 &&
                                    <LookOutRegistered isActive={viewUsers == 1} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={moment(new Date(value.startDate)).format("MM/DD/YYYY")} />
                                }
                                {viewUsers == 2 &&
                                    <LookOutConfirmed isActive={viewUsers == 2} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={moment(new Date(value.startDate)).format("MM/DD/YYYY")} />
                                }
                                {viewUsers == 3 &&
                                    <LookOutEmergency isActive={viewUsers == 3} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={moment(new Date(value.startDate)).format("MM/DD/YYYY")} />
                                }
                            </Card>
                        </div>
                    </>
                }
            </div>
        </Container >
    )
}